import { isFeatureEnabled } from 'owa-feature-flags';
import { isTabletOs } from 'owa-layout';

/**
 * Enable dynamic layout if the flight is enabled or user is using tablet
 */
export function shouldEnableMailDynamicLayout(): boolean {
    return isFeatureEnabled('tri-dynamicLayout') || isTabletOs();
}
